module.exports = __webpack_public_path__ + "assets/img/theX-content-3.f4ecd5e5.png";